module.exports = __webpack_public_path__ + "img/funds-dollar.46afcd1d.svg";